import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IRequestWithHeader, Types } from './types';

// ACTIONS
import { enderecoIpSuccess, enderecoIpFailure } from './actions';

function* enderecoIpRequest(request: ReducerActionRotaSP) {
	const { payload, token }: { payload: IRequestWithHeader; token?: string } =
		request;
	const { headers } = payload;

	// const statusToValidate = [200, 204];
	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`usuarios/acessos`,
		{},
		undefined,
		undefined,
		undefined,
		headers,
		// statusToValidate,
	);

	if (response.status === 200) {
		yield put(enderecoIpSuccess(response.data));
	} else {
		yield put(enderecoIpFailure());
	}
}

export default all([takeLatest(Types.ENDERECO_IP_REQUEST, enderecoIpRequest)]);
